module.exports = __webpack_public_path__ + "static/media/DSCF0070.43d28800.jpg";